import * as Icons from "lucide-react";
import { BENEFITS } from "@/data/content";
import { Reveal, SectionHeading } from "@/components/site/primitives";

export function Benefits() {
  return (
    <section className="relative py-20 sm:py-28 bg-white" data-testid="benefits-section">
      <div className="container-x">
        <SectionHeading
          overline="Why the School of Basic Studies"
          title="More Than a Programme. A Foundation for Success."
          subtitle="Everything about the School is designed to prepare you for the academic demands ahead."
        />
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {BENEFITS.map((b, i) => {
            const Icon = Icons[b.icon] || Icons.Star;
            return (
              <Reveal key={b.title} delay={(i % 3) * 0.08}>
                <div className="group h-full rounded-sm border border-slate-200 bg-[#F7F5EF] p-7 transition-all duration-300 hover:-translate-y-1 hover:border-[#D4AF37] hover:shadow-xl">
                  <div className="flex h-14 w-14 items-center justify-center rounded-sm bg-[#0A1E4E] text-[#D4AF37] transition-colors group-hover:bg-[#C0202A] group-hover:text-white">
                    <Icon size={26} />
                  </div>
                  <h3 className="mt-5 font-serif text-xl font-bold text-[#0A1E4E]">{b.title}</h3>
                  <p className="mt-3 text-slate-600 leading-relaxed">{b.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
